import { useGetCountry } from '../helpers';
import {
  LINKEDIN_LINK,
  INSTAGRAM_LINK,
  WHATSAPP_LINK,
  MAPS_LINK_CHILE,
  MAPS_LINK_MEXICO,
} from '../constants/links';

const useSocialMediaLinks = () => {
  const country = useGetCountry();
  const baseLinks = {
    linkedinLink: LINKEDIN_LINK,
    instagramLink: INSTAGRAM_LINK,
  };
  const countryLinksMapper = {
    Chile: {
      ...baseLinks,
      mapsLink: MAPS_LINK_CHILE,
      whatsappLink: WHATSAPP_LINK,
    },
    Mexico: {
      ...baseLinks,
      mapsLink: MAPS_LINK_MEXICO,
      whatsappLink: WHATSAPP_LINK,
    },
  };
  return countryLinksMapper[country];
};
export default useSocialMediaLinks;
